<template>
  <div id="chart">
    <apexchart type="bar" height="380" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ['indicadores'],
  data() {
    return {
      chartOptions: {
        chart: {
          type: "bar",
          height: 380,
        },
        colors:['#1976D2','#2196F3', '#03A9F4', '#00BCD4', '#26C6DA', '#4DD0E1', '#B2FF59', '#69FFA7', '#5FE8C9'],
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },

        dataLabels: {
          enabled: false,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter: function(val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ": " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: ['I.- FISICO-MATEMATICAS Y CIENCIAS DE LA TIERRA', 'II.- BIOLOGÍA Y QUÍMICA', 'III.- MEDICINA Y CIENCIAS DE LA SALUD', 'IV.- CIENCIAS DE LA CONDUCTA Y EDUCACIÓN', 'V.- HUMANIDADES', 'VI.- CIENCIAS SOCIALES', 'VII.- CIENCIAS DE AGRICULTURA, AGROPECUARIAS, FORESTALES Y DE ECOSISTEMAS', 'VIII.- INGENIERÍAS Y DESARROLLO TECNOLÓGICO', 'IX.- INTERDISCIPLINARIA'
          ],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        tooltip: {
          theme: "dark",
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function(val, opt) {
                return (
                  '<div class="legend-info">' +
                  "<span>" +
                  "<span>" +
                  opt.w.globals.labels[opt.dataPointIndex] +
                  ": " +
                  "</span>" +
                  "</div>"
                );
              },
            },
          },
        },
      },
    };
  },
  computed: {
    series: function() {
      return [
        {
          data: [this.indicadores.fmycdt_total, this.indicadores.byq_total, this.indicadores.mycdls_total, this.indicadores.cdlc_total, this.indicadores.huma_total, this.indicadores.cs_total, this.indicadores.cdafyde_total, this.indicadores.ingydt_total, this.indicadores.inter_total],
        },
      ];
    },
  }
};
</script>
<style>
    .apexcharts-legend{
        justify-content: left !important;
    }

</style>